export const getMemberPlanTypeName = ({ plans, planTypeId }) => {
	return plans.find(plan => plan.id === planTypeId).name;
};
